var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingworkers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ff9800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2h12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22h12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2v4a4 4 0 0 0 2 3.5L12 11l2-1.5A4 4 0 0 0 16 6V2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22v-4a4 4 0 0 1 2-3.5L12 13l2 1.5a4 4 0 0 1 2 3.5v4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingworkers);
export default __webpack_public_path__ + "static/media/pendingworkers.10d6de074bcbefa9741a075c0b29abe9.svg";
export { ForwardRef as ReactComponent };